/**
 * ブログ記事のメタ情報インデックス（一覧・SEO用）。
 *
 * 記事の実体は src/content/blog/<id>.md（front-matter付きMarkdown）。
 * `?meta` 付きimportは scripts/blog-md-loader.js がメタ情報のみに変換するため、
 * ここから本文HTMLはバンドルされない。本文は BlogDetailView が記事単位で
 * 遅延ロードする。
 *
 * 記事を追加したら、ここにimportを1行足すこと（新しい順に並べる）。
 */
import phpVulnerabilityNotMyBusiness from "@/content/blog/php-vulnerability-not-my-business.md?meta";
import engineerCuriosityAi from "@/content/blog/engineer-curiosity-ai.md?meta";
import aiIshDesignDecision from "@/content/blog/ai-ish-design-decision.md?meta";
import earlyBirdOneWeek from "@/content/blog/early-bird-one-week.md?meta";
import fordAiQualityVeterans from "@/content/blog/ford-ai-quality-veterans.md?meta";
import aiSleepLearning from "@/content/blog/ai-sleep-learning.md?meta";
import trainCongestionAiCamera from "@/content/blog/train-congestion-ai-camera.md?meta";
import aiAgentVsHuman from "@/content/blog/ai-agent-vs-human.md?meta";
import kmpIosAndroid from "@/content/blog/kmp-ios-android.md?meta";
import agileRetrospective from "@/content/blog/agile-retrospective.md?meta";
import vue3Vuetify3Corporate from "@/content/blog/vue3-vuetify3-corporate.md?meta";

export const blogPosts = [
  phpVulnerabilityNotMyBusiness,
  engineerCuriosityAi,
  aiIshDesignDecision,
  earlyBirdOneWeek,
  fordAiQualityVeterans,
  aiSleepLearning,
  trainCongestionAiCamera,
  aiAgentVsHuman,
  kmpIosAndroid,
  agileRetrospective,
  vue3Vuetify3Corporate,
];
